// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//main.js 顶部



router.beforeEach((to, from, next) => {
  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)

  if (isMobile) {
    // 手机端：不应用固定样式，保持原样
    // document.body.style.cssText = ''
    // document.documentElement.style.fontSize = ''
  } else if (to.path.startsWith('/gamePage')) {
    // PC端 + 特定路径：不限制
    document.body.style.cssText = ''
    document.documentElement.style.fontSize = ''

  } else if (to.path.startsWith('/recharge')) {
    // PC端 + 特定路径：不限制
    document.body.style.cssText = 'max-width:475px;margin:0 auto;min-height:100vh;background:#fff;box-shadow:0 0 10px rgba(0,0,0,0.1);transform:translateZ(0);'
    // document.documentElement.style.fontSize = '12px'

  } else {
    // PC端 + 其他路径：固定手机端样式

    // document.documentElement.style.fontSize = ''
    document.body.style.cssText = 'max-width:475px;margin:0 auto;min-height:100vh;background:#fff;box-shadow:0 0 10px rgba(0,0,0,0.1);transform:translateZ(0);'

  }
  next()
})

import Vue from 'vue'
import App from './App'
import router from './router'
import apiFun from "@/http/api.js";
// 引入 我们准备好的 store
import store from '@/store/index.js'
// import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css'
// Vue.use(ElementUI);
// import  "amfe-flexible";
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

// 全局注册
Vue.prototype.$apiFun = apiFun;//请求接口api

Vue.config.productionTip = false

router.afterEach((to, from, next) => {
  
  window.scrollTo(0, 0);//每到一个新的页面 就自动回顶
  if(document.querySelector(".index-page")){
    document.querySelector(".index-page").scrollTo(0, 0) ;//

  }
});
router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('token') ? localStorage.getItem('token') : '';
  if (to.matched.some(res => res.meta.requireAuth)) { // 验证是否需要登陆
    if (localStorage.getItem('token')) { // 查询本地存储信息是否已经登陆
      next();
    } else {
      next({
        path: '/login', // 未登录则跳转至login页面
        query: { redirect: to.fullPath } // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
      });
    }
  } else {
    next();
  }


});
/* eslint-disable no-new */
// new Vue({
//   el: '#app',
//   store,//使用store
//   router,
//   components: { App },
//   template: '<App/>'
// })
new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js